import { render, staticRenderFns } from "./PredefineGroupForm.vue?vue&type=template&id=1bd56304&"
import script from "./PredefineGroupForm.vue?vue&type=script&lang=js&"
export * from "./PredefineGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports